import GdprText from "@profilog/misc/user/components/GdprText";
import { useScrollToTop } from "@profilog/commons/hooks/useScrollToTop";

export default function GdprInformation() {
    useScrollToTop();

    return <GdprText type="information" />;
}
